import { DatePicker, Grid, MenuItem, Select } from "../../../components";
import { situacoes } from "../components/constantes";

export default function FormFiltroAvancadoManifestacao ({
  valueInput,
  onChangeInput,
  valueDate,
  onChangeDate,
}) {

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Select
          id="situacao"
          name="situacao"
          value={valueInput("situacao")}
          label="Situação"
          fullWidth
          onChange={onChangeInput}
        >
          {situacoes.map((situacao, index) => (
            <MenuItem key={index} value={situacao.nome}>
              <i
                className="ph-fill ph-circle"
                style={{ color: `${situacao.cor}`, marginRight: 4 }}
              ></i>
              {situacao.label}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          id="dataEmissaoStart"
          name="dataEmissaoStart"
          label="Data Emissão De"
          format="dd/MM/yyyy"
          value={valueDate("dataEmissaoStart")}
          onChange={(date) => onChangeDate("dataEmissaoStart", date)}
        />
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          id="dataEmissaoEnd"
          name="dataEmissaoEnd"
          label="Data Emissão Até"
          format="dd/MM/yyyy"
          value={valueDate("dataEmissaoEnd")}
          onChange={(date) => onChangeDate("dataEmissaoEnd", date)}
        />
      </Grid>
    </Grid>
  );
}